module.exports = __webpack_public_path__ + "img/linkedin-icon.95a5772a.svg";